import { __awaiter } from "tslib";
import { _Web, Web } from "../webs/types.js";
import { spPost } from "../operations.js";
_Web.prototype.hubSiteData = function (forceRefresh = false) {
    return __awaiter(this, void 0, void 0, function* () {
        const data = yield this.clone(Web, `hubSiteData(${forceRefresh})`)();
        if (typeof data === "string") {
            return JSON.parse(data);
        }
        return data;
    });
};
_Web.prototype.syncHubSiteTheme = function () {
    return spPost(this.clone(Web, "syncHubSiteTheme"));
};
//# sourceMappingURL=web.js.map